import { createStore } from 'vuex';

import navigator from './modules/navigator.js';
import checkout from './modules/checkout.js';
import cart from './modules/cart.js';
import twister from './modules/twister.js';
import yourOrder from './modules/yourOrder.js';
import share from './modules/share.js';
import yourAccount from './modules/yourAccount.js';
import common from './modules/common.js';
import landingPage from './modules/landingPage.js';

export default createStore({
  state: {
    appConfigData: {}
  },
  getters: {},
  mutations: {
    setAppConfigData(state, data) {
      state.appConfigData = data;
    }
  },
  actions: {},
  modules: {
    navigator,
    checkout,
    cart,
    twister,
    yourOrder,
    share,
    yourAccount,
    common,
    landingPage
  }
});
